'use client'

import { useAlertBoxState } from "@/app/store";

export default function Header(){

    const { setAlertState } = useAlertBoxState();

    return(
        <div id="header" className="w-100" style={{margin : 'auto'}}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-gear-fill setting-emogi float-end" viewBox="0 0 16 16" onClick={() => {
                setAlertState();
            }}>
                <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"/>
            </svg>
            <p className="header-title text-left p-0 mt-2">
                꼬들꼬들 - 단어 유사도 추측 게임
            </p>
            <div style={{clear : 'both'}}></div>
        </div>
    )
}

